/**
 * Automation Types Registry
 *
 * Extensible list of automation kinds. Today only `recurring-task` is shipping,
 * but the page and type picker iterate this registry so adding a new kind
 * (e.g. due-soon reminders, auto-archive) is additive — no UI rewrite needed.
 *
 * Shape:
 *   id         — stored on the rule's `type` field (matches automationService)
 *   labelKey   — i18n key for display name
 *   hintKey    — i18n key for short description
 *   icon       — single-character glyph
 *   available  — whether the user can create rules of this type today
 *   groupKey   — i18n key for the list-section heading
 */

export const AUTOMATION_TYPES = [
    {
        id: 'recurring-task',
        labelKey: 'automations.type.recurringTask',
        hintKey: 'automations.type.recurringTaskHint',
        icon: '🔄',
        available: true,
        groupKey: 'automations.group.recurringTask'
    },
    {
        id: 'due-soon',
        labelKey: 'automations.type.dueSoon',
        hintKey: 'automations.typePicker.comingSoon',
        icon: '⏰',
        available: false,
        groupKey: null
    },
    {
        id: 'auto-archive',
        labelKey: 'automations.type.autoArchive',
        hintKey: 'automations.type.autoArchiveHint',
        icon: '📦',
        available: true,
        groupKey: 'automations.group.autoArchive'
    }
];

export function getAutomationType(id) {
    return AUTOMATION_TYPES.find((t) => t.id === id) || AUTOMATION_TYPES[0];
}

export function getAvailableAutomationTypes() {
    return AUTOMATION_TYPES.filter((t) => t.available);
}
